import { IPiAuthParams } from 'contexts/types/authUserContext';
import { IAuthUser } from 'types/authUser';
import { ICapabilitiesForUser, ISelf } from 'types/types.generated';
import { UserCapabilityName } from 'types/userCapabilityName';

/**
 * Extract the info from the url sent over from PiNxt when a user logs in via ESSO
 */
export const parsePiNxtPostEssoQuery = (): IPiAuthParams => {
  const urlParams = new URLSearchParams(window.location.search);
  return Object.fromEntries(urlParams) as unknown as IPiAuthParams;
};

export const hasCapability = (
  neededCapabilities: UserCapabilityName | UserCapabilityName[],
  currentCapabilities: UserCapabilityName[]
): boolean => {
  const capabilities = Array.isArray(neededCapabilities)
    ? neededCapabilities
    : [neededCapabilities];
  if (capabilities.length === 0) {
    return true;
  }

  return capabilities.some((cap) => currentCapabilities.includes(cap));
};

/**
 * Builds the auth user onces all the data sources are finished returning data about the user.
 */
export const buildAuthUser = (
  selfData: ISelf,
  capabilitiesData: ICapabilitiesForUser
): IAuthUser => {
  const { id, firstName, lastName, phone, email, pid } = selfData;

  const capabilities =
    capabilitiesData.capabilities
      ?.map((item) => item?.name || '')
      .filter((name) => !!name)
      .map((name) => name as UserCapabilityName) || [];

  return {
    id,
    firstName,
    lastName,
    phone,
    email,
    pid,
    capabilities,
  };
};
